export const mockProductTemplate = {
  activity: 'Lifestyle',
  brandName: 'Nike',
  breadcrumbPath: [
    {
      slug: 'nike',
      name: 'Nike',
    },
  ],
  careInstructions: 'Be Careful',
  color: 'Black',
  composition: 'cotton',
  designer: 'Tinker Hatfield',
  details: 'black/black-laser crimson',
  fit: 'Fit',
  gender: ['men'],
  id: '12947',
  internalShot: 'taken',
  maximumOfferCents: 200000,
  midsole: 'fast',
  minimumOfferCents: 2500,
  modelSizing: 'Model Sizing',
  name: 'air foamposite pro prm',
  nickname: 'testy mctestface mcdude',
  productCategory: 'shoes',
  productType: 'sneakers',
  releaseDate: {
    value: '2014-04-19T23:59:59.999Z',
    shortDisplay: '4/19/14',
  },
  releaseDateName: 'Release Date Name',
  season: 'Spring/Summer 1970',
  silhouette: 'Foamposite Pro',
  sizeBrand: 'nike',
  sizeRange: [
    3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10, 10.5, 11, 11.5, 12, 12.5, 13, 13.5, 14,
    14.5, 15, 15.5, 16, 16.5, 17, 17.5, 18,
  ],
  sizeType: 'numeric_sizes',
  sizeUnit: 'us',
  sku: '616750 001',
  slug: 'air-foamposite-pro-prm-black-black-laser-crimson-042112',
  specialDisplayPriceCents: 25000,
  specialType: 'standard',
  status: 'active',
  upperMaterial: 'leather',
  availableSizesNew: [],
  availableSizesNewV2: [],
  availableSizesNewWithDefects: [],
  availableSizesUsed: [],
  sizeOptions: [
    {
      presentation: '3.5',
      value: 3.5,
    },
    {
      presentation: '4',
      value: 4,
    },
    {
      presentation: '4.5',
      value: 4.5,
    },
    {
      presentation: '5',
      value: 5,
    },
    {
      presentation: '5.5',
      value: 5.5,
    },
    {
      presentation: '6',
      value: 6,
    },
    {
      presentation: '6.5',
      value: 6.5,
    },
    {
      presentation: '7',
      value: 7,
    },
    {
      presentation: '7.5',
      value: 7.5,
    },
    {
      presentation: '8',
      value: 8,
    },
    {
      presentation: '8.5',
      value: 8.5,
    },
    {
      presentation: '9',
      value: 9,
    },
    {
      presentation: '9.5',
      value: 9.5,
    },
    {
      presentation: '10',
      value: 10,
    },
    {
      presentation: '10.5',
      value: 10.5,
    },
    {
      presentation: '11',
      value: 11,
    },
    {
      presentation: '11.5',
      value: 11.5,
    },
    {
      presentation: '12',
      value: 12,
    },
    {
      presentation: '12.5',
      value: 12.5,
    },
    {
      presentation: '13',
      value: 13,
    },
    {
      presentation: '13.5',
      value: 13.5,
    },
    {
      presentation: '14',
      value: 14,
    },
    {
      presentation: '14.5',
      value: 14.5,
    },
    {
      presentation: '15',
      value: 15,
    },
    {
      presentation: '15.5',
      value: 15.5,
    },
    {
      presentation: '16',
      value: 16,
    },
    {
      presentation: '16.5',
      value: 16.5,
    },
    {
      presentation: '17',
      value: 17,
    },
    {
      presentation: '17.5',
      value: 17.5,
    },
    {
      presentation: '18',
      value: 18,
    },
  ],
  lowestPriceCents: 0,
  newLowestPriceCents: 0,
  usedLowestPriceCents: 0,
  productTaxonomy: [
    {
      name: 'Nike',
      slug: 'navigation/nike',
    },
  ],
  featuredIn: [],
  localizedSpecialDisplayPriceCents: {
    display: '$250',
    localizedValue: 25000,
    value: 25000,
  },
  category: ['Basketball'],
  micropostsCount: 0,
  sellingCount: 0,
  usedForSaleCount: 0,
  withDefectForSaleCount: 0,
  isWantable: true,
  isOwnable: true,
  isResellable: true,
  isOfferable: true,
  isAvailabilityRestricted: false,
  directShipping: false,
  isFashionProduct: false,
  isRaffleProduct: false,
  renderImagesInOrder: false,
  applePayOnlyPromo: false,
  singleGender: 'men',
  storyHtml:
    '<p>Sneakers go back a long way. In the late 18th century, people wore rubber soled shoes called plimsolls, but they were pretty crude—for one thing, there was no right foot or left foot. </p>\n',
  story:
    'Sneakers go back a long way. In the late 18th century, people wore rubber soled shoes called plimsolls, but they were pretty crude—for one thing, there was no right foot or left foot. ',
  pictureUrl: 'https://cdn-staging.flightclub.com/TEMPLATE/042112/1.jpg',
  mainGlowPictureUrl: 'https://cdn-staging.flightclub.com/TEMPLATE/042112/1.jpg',
  mainPictureUrl: 'https://cdn-staging.flightclub.com/TEMPLATE/042112/1.jpg',
  gridGlowPictureUrl: 'https://cdn-staging.flightclub.com/TEMPLATE/042112/1.jpg',
  gridPictureUrl: 'https://cdn-staging.flightclub.com/TEMPLATE/042112/1.jpg',
  userWant: false,
  userOwn: false,
  robotAssets: [],
  productTemplateExternalPictures: [
    {
      mainPictureUrl: 'https://cdn-staging.flightclub.com/TEMPLATE/042112/2.jpg',
      gridPictureUrl: 'https://cdn-staging.flightclub.com/TEMPLATE/042112/2.jpg',
      sourceUrl: 'https://www.flightclub.com',
      attributionUrl: 'Flight Club',
      aspect: 1,
      order: 2,
    },
    {
      mainPictureUrl: 'https://cdn-staging.flightclub.com/TEMPLATE/042112/3.jpg',
      gridPictureUrl: 'https://cdn-staging.flightclub.com/TEMPLATE/042112/3.jpg',
      sourceUrl: 'https://www.flightclub.com',
      attributionUrl: 'Flight Club',
      aspect: 1,
      order: 3,
    },
    {
      mainPictureUrl: 'https://cdn-staging.flightclub.com/TEMPLATE/042112/4.jpg',
      gridPictureUrl: 'https://cdn-staging.flightclub.com/TEMPLATE/042112/4.jpg',
      sourceUrl: 'https://www.flightclub.com',
      attributionUrl: 'Flight Club',
      aspect: 1,
      order: 4,
    },
  ],
  brand: 'Nike',
  description: 'black/black-laser crimson',
  fetchedServerSide: true,
  pictures: [
    'https://cdn-staging.flightclub.com/TEMPLATE/042112/1.jpg',
    'https://cdn-staging.flightclub.com/TEMPLATE/042112/2.jpg',
    'https://cdn-staging.flightclub.com/TEMPLATE/042112/3.jpg',
    'https://cdn-staging.flightclub.com/TEMPLATE/042112/4.jpg',
  ],
  sizeCategory: 'men',
  isNewInStock: true,
  newCount: 10,
  newHighestPrice: {
    display: '$240',
    localizedValue: 24000,
    value: 24000,
  },
  newLowestPrice: {
    display: '$25',
    localizedValue: 2500,
    value: 2500,
  },
  newSizes: [
    {
      productTemplateId: '12947',
      size: {
        value: 3.5,
        display: '3.5',
      },
      lowestPriceOption: {
        price: {
          display: '$25',
          localizedValue: 2500,
          value: 2500,
        },
        isAvailable: true,
      },
      boxCondition: 'good_condition',
      shoeCondition: 'new_no_defects',
      instantShipPriceOption: {
        price: null,
        isAvailable: false,
      },
      isInstantShip: false,
    },
    {
      productTemplateId: '12947',
      size: {
        value: 4,
        display: '4',
      },
      lowestPriceOption: {
        price: {
          display: '$240',
          localizedValue: 24000,
          value: 24000,
        },
        isAvailable: true,
      },
      boxCondition: 'good_condition',
      shoeCondition: 'new_no_defects',
      instantShipPriceOption: {
        price: null,
        isAvailable: false,
      },
      isInstantShip: false,
    },
    {
      productTemplateId: '12947',
      size: {
        value: 5,
        display: '5',
      },
      lowestPriceOption: {
        price: {
          display: '$80',
          localizedValue: 8000,
          value: 8000,
        },
        isAvailable: true,
      },
      boxCondition: 'good_condition',
      shoeCondition: 'new_no_defects',
      instantShipPriceOption: {
        price: null,
        isAvailable: false,
      },
      isInstantShip: false,
    },
    {
      productTemplateId: '12947',
      size: {
        value: 8,
        display: '8',
      },
      lowestPriceOption: {
        price: {
          display: '$175',
          localizedValue: 17500,
          value: 17500,
        },
        isAvailable: true,
      },
      boxCondition: 'good_condition',
      shoeCondition: 'new_no_defects',
      instantShipPriceOption: {
        price: null,
        isAvailable: false,
      },
      isInstantShip: false,
    },
    {
      productTemplateId: '12947',
      size: {
        value: 9,
        display: '9',
      },
      lowestPriceOption: {
        price: {
          display: '$77',
          localizedValue: 7700,
          value: 7700,
        },
        isAvailable: true,
      },
      boxCondition: 'good_condition',
      shoeCondition: 'new_no_defects',
      instantShipPriceOption: {
        price: null,
        isAvailable: false,
      },
      isInstantShip: false,
    },
    {
      productTemplateId: '12947',
      size: {
        value: 10,
        display: '10',
      },
      lowestPriceOption: {
        price: {
          display: '$25',
          localizedValue: 2500,
          value: 2500,
        },
        isAvailable: true,
      },
      boxCondition: 'good_condition',
      shoeCondition: 'new_no_defects',
      instantShipPriceOption: {
        price: null,
        isAvailable: false,
      },
      isInstantShip: false,
    },
    {
      productTemplateId: '12947',
      size: {
        value: 11,
        display: '11',
      },
      lowestPriceOption: {
        price: {
          display: '$50',
          localizedValue: 5000,
          value: 5000,
        },
        isAvailable: true,
      },
      boxCondition: 'good_condition',
      shoeCondition: 'new_no_defects',
      instantShipPriceOption: {
        price: {
          display: '$54',
          localizedValue: 5400,
          value: 5400,
        },
        isAvailable: true,
      },
      isInstantShip: false,
    },
    {
      productTemplateId: '12947',
      size: {
        value: 11.5,
        display: '11.5',
      },
      lowestPriceOption: {
        price: {
          display: '$50',
          localizedValue: 5000,
          value: 5000,
        },
        isAvailable: true,
      },
      boxCondition: 'good_condition',
      shoeCondition: 'new_no_defects',
      instantShipPriceOption: {
        price: null,
        isAvailable: false,
      },
      isInstantShip: false,
    },
    {
      productTemplateId: '12947',
      size: {
        value: 14,
        display: '14',
      },
      lowestPriceOption: {
        price: {
          display: '$25',
          localizedValue: 2500,
          value: 2500,
        },
        isAvailable: true,
      },
      boxCondition: 'good_condition',
      shoeCondition: 'new_no_defects',
      instantShipPriceOption: {
        price: {
          display: '$27',
          localizedValue: 2700,
          value: 2700,
        },
        isAvailable: true,
      },
      isInstantShip: false,
    },
    {
      productTemplateId: '12947',
      size: {
        value: 17,
        display: '17',
      },
      lowestPriceOption: {
        price: {
          display: '$150',
          localizedValue: 15000,
          value: 15000,
        },
        isAvailable: true,
      },
      boxCondition: 'good_condition',
      shoeCondition: 'new_no_defects',
      instantShipPriceOption: {
        price: null,
        isAvailable: false,
      },
      isInstantShip: false,
    },
  ],
  sizePickerDefault: {
    new: {
      boxCondition: 'good_condition',
      lowestPriceCents: {
        display: '$25',
        localizedValue: 2500,
        value: 2500,
      },
      shoeCondition: 'new_no_defects',
      size: {
        display: '10',
        value: 10,
      },
    },
    size: {
      display: '10',
      value: 10,
    },
  },
  sizePickerOptions: [
    {
      new: {
        boxCondition: 'good_condition',
        lowestPriceCents: {
          display: '$25',
          localizedValue: 2500,
          value: 2500,
        },
        shoeCondition: 'new_no_defects',
        size: {
          display: '7.5',
          value: 7.5,
        },
      },
      size: {
        display: '7.5',
        value: 7.5,
      },
    },
    {
      new: {
        boxCondition: 'good_condition',
        lowestPriceCents: {
          display: '$240',
          localizedValue: 24000,
          value: 24000,
        },
        shoeCondition: 'new_no_defects',
        size: {
          display: '4',
          value: 4,
        },
      },
      size: {
        display: '4',
        value: 4,
      },
    },
    {
      new: {
        boxCondition: 'good_condition',
        lowestPriceCents: {
          display: '$80',
          localizedValue: 8000,
          value: 8000,
        },
        shoeCondition: 'new_no_defects',
        size: {
          display: '5',
          value: 5,
        },
      },
      size: {
        display: '5',
        value: 5,
      },
    },
    {
      new: {
        boxCondition: 'good_condition',
        lowestPriceCents: {
          display: '$175',
          localizedValue: 17500,
          value: 17500,
        },
        shoeCondition: 'new_no_defects',
        size: {
          display: '8',
          value: 8,
        },
      },
      size: {
        display: '8',
        value: 8,
      },
    },
    {
      new: {
        boxCondition: 'good_condition',
        lowestPriceCents: {
          display: '$77',
          localizedValue: 7700,
          value: 7700,
        },
        shoeCondition: 'new_no_defects',
        size: {
          display: '9',
          value: 9,
        },
      },
      size: {
        display: '9',
        value: 9,
      },
    },
    {
      new: {
        boxCondition: 'good_condition',
        lowestPriceCents: {
          display: '$25',
          localizedValue: 2500,
          value: 2500,
        },
        shoeCondition: 'new_no_defects',
        size: {
          display: '10',
          value: 10,
        },
      },
      size: {
        display: '10',
        value: 10,
      },
    },
    {
      new: {
        boxCondition: 'good_condition',
        instantShipLowestPriceCents: {
          display: '$54',
          localizedValue: 5400,
          value: 5400,
        },
        lowestPriceCents: {
          display: '$50',
          localizedValue: 5000,
          value: 5000,
        },
        shoeCondition: 'new_no_defects',
        size: {
          display: '11',
          value: 11,
        },
      },
      size: {
        display: '11',
        value: 11,
      },
    },
    {
      new: {
        boxCondition: 'good_condition',
        lowestPriceCents: {
          display: '$50',
          localizedValue: 5000,
          value: 5000,
        },
        shoeCondition: 'new_no_defects',
        size: {
          display: '11.5',
          value: 11.5,
        },
      },
      size: {
        display: '11.5',
        value: 11.5,
      },
    },
    {
      new: {
        boxCondition: 'good_condition',
        instantShipLowestPriceCents: {
          display: '$27',
          localizedValue: 2700,
          value: 2700,
        },
        lowestPriceCents: {
          display: '$25',
          localizedValue: 2500,
          value: 2500,
        },
        shoeCondition: 'new_no_defects',
        size: {
          display: '14',
          value: 14,
        },
      },
      size: {
        display: '14',
        value: 14,
      },
    },
    {
      new: {
        boxCondition: 'good_condition',
        lowestPriceCents: {
          display: '$150',
          localizedValue: 15000,
          value: 15000,
        },
        shoeCondition: 'new_no_defects',
        size: {
          display: '17',
          value: 17,
        },
      },
      size: {
        display: '17',
        value: 17,
      },
    },
  ],
  usedLowestPrice: null,
  offers: [
    {
      sku: '886915767937',
      itemCondition: 'NewCondition',
      price: '77.00',
      priceCurrency: 'USD',
      size: 9,
      availability: 'http://schema.org/InStock',
    },
    {
      sku: '123456789205',
      itemCondition: 'NewCondition',
      price: '25.00',
      priceCurrency: 'USD',
      size: 3.5,
      availability: 'http://schema.org/InStock',
    },
    {
      sku: '857777004201',
      itemCondition: 'NewCondition',
      price: '50.00',
      priceCurrency: 'USD',
      size: 11,
      availability: 'http://schema.org/InStock',
    },
    {
      sku: '886915767951',
      itemCondition: 'NewCondition',
      price: '25.00',
      priceCurrency: 'USD',
      size: 10,
      availability: 'http://schema.org/InStock',
    },
    {
      sku: '886915767944',
      itemCondition: 'NewCondition',
      price: '175.00',
      priceCurrency: 'USD',
      size: 8,
      availability: 'http://schema.org/InStock',
    },
    {
      sku: '616750 0014',
      itemCondition: 'NewCondition',
      price: '240.00',
      priceCurrency: 'USD',
      size: 4,
      availability: 'http://schema.org/InStock',
    },
    {
      sku: '616750 0015',
      itemCondition: 'NewCondition',
      price: '80.00',
      priceCurrency: 'USD',
      size: 5,
      availability: 'http://schema.org/InStock',
    },
    {
      sku: '098765567890',
      itemCondition: 'NewCondition',
      price: '150.00',
      priceCurrency: 'USD',
      size: 17,
      availability: 'http://schema.org/InStock',
    },
    {
      sku: '616750 00114',
      itemCondition: 'NewCondition',
      price: '25.00',
      priceCurrency: 'USD',
      size: 14,
      availability: 'http://schema.org/InStock',
    },
    {
      sku: '886915767982',
      itemCondition: 'NewCondition',
      price: '50.00',
      priceCurrency: 'USD',
      size: 11.5,
      availability: 'http://schema.org/InStock',
    },
  ],
}
